import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

import axios from 'axios'
const router = new Router({
    routes: [
        {
            path: '/',
            name: '/',
            component: () => import('@/components/home'),
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/components/Login'),
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/components/home'),
            children: []
        },
        {
            path: '/my',
            name: 'my',
            component: () => import('@/components/my'),
            children: []
        },
        {
            path: '/changepw',
            name: 'changepw',
            component: () => import('@/components/changepw'),
            children: []
        },
        {
            path: '/target',
            name: 'target',
            component: () => import('@/components/targetInfo'),
            children: []
        },
    ]
})

router.beforeEach(async (to, from, next) => {
    if (to.fullPath.indexOf('login') == -1) {
        // 非登录页---判断是否登录
        let user = JSON.parse(localStorage.getItem('user'))
		
		let user_ = to.query.info ? decodeURI(to.query.info) : null;
		if(user_){
			localStorage.setItem("user",JSON.stringify(JSON.parse(user_)));
		}
        if (user || user_) {
            if (to.path == '/') {
                return next({ path: '/home' })
            } else {
                next();
            }
        } else {
            return next({ path: '/login' })
        }
    } else {
		// if(to.fullPath.indexOf("openId=") != -1){
		// 	let openId = to.query.openId;
		// 	let res = await axios.get("/wechat-api/userInfo1/getInfo?openId="+openId)
		// 	if(res && res.data!=""){
		// 		debugger
		// 		localStorage.setItem('user',JSON.stringify(JSON.parse(decodeURI(res.data))))
		// 		next({ path: '/home' })
		// 	}
		// }
		next()
    }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js